import { Injectable } from '@angular/core';

import { TmsWebBaseEditService } from 'tms-web-shared';
import { ProductionCalendar } from '../../../models';

@Injectable({
  providedIn: 'root',
})
export class ProductionCalendarService extends TmsWebBaseEditService<ProductionCalendar, ProductionCalendar> {
  constructor() {
    super('ProductionCalendar', $localize`Production Calendar`);
  }
}
